module.exports = __webpack_public_path__ + "img/scroller-media.c77e6256.png";